import { SnackbarKey } from 'notistack';

export const ToastVariant = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export type ToastVariant = (typeof ToastVariant)[keyof typeof ToastVariant];

export interface ToastOptions {
  /** Optional bold title displayed above the message */
  title?: string;
  /** Duration in ms. Defaults per variant. null = no auto-dismiss. */
  duration?: number | null;
  /** Whether toast persists until dismissed. Overrides duration. */
  persist?: boolean;
  /** Prevent showing duplicate messages. Default: true */
  preventDuplicate?: boolean;
  /** Optional action element */
  action?: React.ReactNode;
}

export interface B2ChatToastApi {
  success: (message: string, options?: ToastOptions) => SnackbarKey;
  error: (message: string, options?: ToastOptions) => SnackbarKey;
  warning: (message: string, options?: ToastOptions) => SnackbarKey;
  info: (message: string, options?: ToastOptions) => SnackbarKey;
  close: (key?: SnackbarKey) => void;
}
